<template>
  <div>
    <div class="titlePageSub mt-3">Exportação</div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsSolicitacoesExportacao"
          orderby="data_finalizacao"
          :optionsButton="optionsButton"
          :items="lstSolicitacaoExportacao"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :titlePDF="titlePage"
          :mostrarQuantidade="false"
        ></fccTable>
      </div>
    </div>
    <fcc-modal
      centered
      id-modal="addStatusTestes"
      title-modal="Testes"
      esconde-footer
      trava-esc
      size="lg"
      trava-back
    >
      <FccTestesCandidato
        :baseUrlPublicacao="baseUrlPublicacao"
        :controlePage="controlePage"
        :idNotificacao="idNotificacao"
      />
    </fcc-modal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../store'
import FccTestesCandidato from './fccTestesCandidato.vue'

export default {
  data() {
    return {
      titlePage: 'Publicações',
      titleModalExportacao: '',
      sortBy: 'nome',
      itemPorPage: '1000',
      lstSolicitacaoExportacao: [],
      permissao: null,
      solicitacao: {},
      fieldsSolicitacoesExportacao: [
        { key: 'nome_funcionario', label: 'Técnico', sortable: true },
        { key: 'dt_importacao', label: 'Data da Exportação', sortable: true }
      ],
      optionsButton: [
        {
          funcaoButton: 'executarField',
          tooltip: 'Exportar',
          icon: 'file-export',
          text: 'Exportar',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          funcaoButton: 'testesField',
          tooltip: 'Testes',
          icon: 'user',
          text: 'Testes',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  methods: {
    testesField() {
      this.$root.$emit('bv::show::modal', 'addStatusTestes')
    },
    executarField() {
      this.callConfirm('Deseja exportar? ', '').then((result) => {
        if (result.value) {
          const criar = {
            spi: this.controlePage.spi,
            idPublicacao: this.idNotificacao,
            idPublicacaoSgp: this.controlePage.idpublicacao,
            cdFuncionario: this.dadosUserSession.usuCdFuncionario
          }
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .post(
              this.baseUrlPublicacao + 'InscricoesDeferidasCanceladas/ExportarTratamentoInscricao',
              criar,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then((response) => {
              if (response.status == 204) {
                this.callAlert('Fechamento de Cadastro não foi finalizado', '', 'error', 'error')
                return
              }

              this.$root.$emit('bv::hide::modal', 'addStatusTestes')
              this.callToast('Exportado com sucesso', 'success')
              this.listarExportacaoInscricaoExportar()
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },
    listarExportacaoInscricaoExportar() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarExportacaoInscricaoExportarGenerico(this.controlePage.spi, 0).then((response) => {
        this.lstSolicitacaoExportacao = response
        this.$emit('exportarOk', this.lstSolicitacaoExportacao.length > 0 ? true : false)
        this.carregaTexto()
      })
    }
  },
  components: {
    FccTestesCandidato
  },
  props: {
    controlePage: Object,
    idNotificacao: Number,
    baseUrlPublicacao: String
  },
  mounted() {
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
    if (this.permissao == null) {
      this.optionsButton = [
        {
          funcaoButton: 'testesField',
          tooltip: 'Testes',
          icon: 'user',
          text: 'Testes',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
    this.listarExportacaoInscricaoExportar()
  }
}
</script>
